"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _useMounted = _interopRequireDefault(require("react-utils/hooks/useMounted"));

var _usePrevious = _interopRequireDefault(require("react-utils/hooks/usePrevious"));

var _ModalTransitionContext = require("../context/ModalTransitionContext");

var _EventHandlers = require("../core/EventHandlers");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _memoWithDisplayName = _interopRequireDefault(require("../utils/memoWithDisplayName"));

var _domElement = _interopRequireDefault(require("../utils/propTypes/domElement"));

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _PlacementConstants = require("./PlacementConstants");

var _UIAbstractPopup = _interopRequireDefault(require("./UIAbstractPopup"));

var _UIPopoverArrow = _interopRequireDefault(require("./UIPopoverArrow"));

var _UIPopoverContent = _interopRequireDefault(require("./UIPopoverContent"));

var _Placement = require("./utils/Placement");

var _propTypes2 = require("./utils/propTypes");

var getArrowSize = function getArrowSize(arrowSize, use) {
  if (arrowSize != null) return arrowSize;
  if (use === 'tooltip' || use === 'tooltip-danger') return 'small';
  return 'medium';
};

var getAnimateOnToggle = function getAnimateOnToggle(animateOnToggle, computedArrowSize) {
  return animateOnToggle != null ? animateOnToggle : computedArrowSize !== 'none';
};

var UIPopover = (0, _memoWithDisplayName.default)('UIPopover', function (props) {
  var _bodyElement = props._bodyElement,
      _distanceAdjustment = props._distanceAdjustment,
      _insetAdjustment = props._insetAdjustment,
      addTargetClasses = props.addTargetClasses,
      animateOnMount = props.animateOnMount,
      animateOnToggle = props.animateOnToggle,
      arrowSize = props.arrowSize,
      autoPlacement = props.autoPlacement,
      children = props.children,
      className = props.className,
      closeOnOutsideClick = props.closeOnOutsideClick,
      closeOnTargetLeave = props.closeOnTargetLeave,
      onChangePlacement = props.onChangePlacement,
      onCloseComplete = props.onCloseComplete,
      onFocusLeave = props.onFocusLeave,
      onOpenChange = props.onOpenChange,
      open = props.open,
      pinToConstraint = props.pinToConstraint,
      pinToOutOfBoundsTarget = props.pinToOutOfBoundsTarget,
      placement = props.placement,
      popoverRef = props.popoverRef,
      shouldCloseOnClick = props.shouldCloseOnClick,
      target = props.target,
      targetAttachment = props.targetAttachment,
      use = props.use,
      zIndex = props.zIndex,
      rest = (0, _objectWithoutProperties2.default)(props, ["_bodyElement", "_distanceAdjustment", "_insetAdjustment", "addTargetClasses", "animateOnMount", "animateOnToggle", "arrowSize", "autoPlacement", "children", "className", "closeOnOutsideClick", "closeOnTargetLeave", "onChangePlacement", "onCloseComplete", "onFocusLeave", "onOpenChange", "open", "pinToConstraint", "pinToOutOfBoundsTarget", "placement", "popoverRef", "shouldCloseOnClick", "target", "targetAttachment", "use", "zIndex"]);

  var _useContext = (0, _react.useContext)(_ModalTransitionContext.ModalTransitionContext),
      inModalTransition = _useContext.transitioning;

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      closeComplete = _useState2[0],
      setCloseComplete = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      placementOverride = _useState4[0],
      setPlacementOverride = _useState4[1];
  /** `contentOpen` triggers open/close transitions */


  var contentOpen = open && !inModalTransition;
  /** `tetherOpen` determines whether the popover is in the DOM */

  var tetherOpen = contentOpen || !closeComplete; // If a close transition is starting, update the closeComplete state.

  var prevContentOpen = (0, _usePrevious.default)(contentOpen);

  if (prevContentOpen && !contentOpen && closeComplete) {
    setCloseComplete(false);
  } // If the placement prop is reset, clear our internal override


  var prevPlacement = (0, _usePrevious.default)(placement);

  if (prevPlacement !== placement && placementOverride) {
    setPlacementOverride(null);
  }

  var contentRef = (0, _react.useRef)();
  var defaultPopoverRef = (0, _react.useRef)();
  var computedPlacement = placementOverride || placement;
  var computedPopoverRef = popoverRef || defaultPopoverRef;
  var mountedRef = (0, _useMounted.default)();
  var isMounted = mountedRef.current;
  (0, _react.useEffect)(function () {
    if (contentOpen && onOpenChange) {
      var tetherTarget = target || computedPopoverRef.current.getTargetElement();

      var handleWindowClick = function handleWindowClick(evt) {
        // If `shouldCloseOnClick` is provided and returns a non-null value, defer to it
        if (shouldCloseOnClick) {
          var shouldClose = shouldCloseOnClick(evt);

          if (shouldClose != null) {
            if (shouldClose) onOpenChange((0, _SyntheticEvent.default)(false));
            return;
          }
        } // Otherwise, use our standard algorithm for detecting "outside clicks"


        var clickTarget = evt.target;
        var contentEl = (0, _reactDom.findDOMNode)(contentRef.current); // Ignore the click if it's within our Tether target

        if (tetherTarget && tetherTarget.contains(clickTarget)) return; // Ignore the click if it's within our popover container

        if (contentEl && (0, _EventHandlers.isClickWithinContainer)(evt, contentEl)) return; // Otherwise, trigger close

        onOpenChange((0, _SyntheticEvent.default)(false));
      };

      var bindClickHandlerFrame;

      if (closeOnOutsideClick) {
        bindClickHandlerFrame = requestAnimationFrame(function () {
          // Wait a tick to prevent the same click that triggered open from triggering close
          addEventListener('click', handleWindowClick);
        });
      } // When closeOnTargetLeave is enabled, we use an IntersectionObserver to close the popover if
      // its target leaves the screen due to scrolling (#3856).


      var intersectionObserver;

      if (closeOnTargetLeave) {
        var _window = window,
            IntersectionObserver = _window.IntersectionObserver;

        if (IntersectionObserver) {
          intersectionObserver = new IntersectionObserver(function (entries) {
            var isIntersecting = entries[0].isIntersecting;

            if (!isIntersecting) {
              onOpenChange((0, _SyntheticEvent.default)(false));
            }
          });
          intersectionObserver.observe(tetherTarget);
        }
      }

      return function () {
        cancelAnimationFrame(bindClickHandlerFrame);
        removeEventListener('click', handleWindowClick);

        if (intersectionObserver) {
          intersectionObserver.disconnect();
        }
      };
    }

    return undefined;
  },
  /* eslint-disable react-hooks/exhaustive-deps */
  [closeOnOutsideClick, closeOnTargetLeave, contentOpen, shouldCloseOnClick, target]
  /* eslint-enable react-hooks/exhaustive-deps */
  );

  var handleTetherUpdate = function handleTetherUpdate(evt) {
    // Adjust our placement state to reflect Tether's response to a constraint
    var newPlacement = (0, _Placement.computeNewPlacement)(computedPlacement, evt.targetAttachment, autoPlacement);
    if (!newPlacement) return;

    if (placementOverride !== newPlacement) {
      setPlacementOverride(newPlacement);
      if (onChangePlacement) onChangePlacement({
        newPlacement: newPlacement
      });
    }
  };

  var handleCloseComplete = function handleCloseComplete() {
    if (onCloseComplete) onCloseComplete();
    if (isMounted) setCloseComplete(true);
  }; // Perf: Don't generate props for the tether if we're closed.


  var popupProps = null;

  if (tetherOpen) {
    var computedArrowSize = getArrowSize(arrowSize, use);
    var computedAnimateOnToggle = getAnimateOnToggle(animateOnToggle, computedArrowSize);
    var computedArrowParams = _UIPopoverArrow.default.ARROW_SIZES[computedArrowSize];

    var renderedContent = _react.default.createElement(_UIPopoverContent.default, (0, _extends2.default)({}, rest, {
      animateOnMount: Boolean(animateOnMount && !isMounted || computedAnimateOnToggle && isMounted),
      animateOnToggle: computedAnimateOnToggle,
      arrowSize: computedArrowSize,
      className: className,
      "data-component-name": "UIPopover",
      onCloseComplete: handleCloseComplete,
      open: contentOpen,
      placement: computedPlacement,
      ref: contentRef,
      use: use,
      onOpenChange: onOpenChange
    }));

    popupProps = {
      addTargetClasses: addTargetClasses,
      autoPlacement: autoPlacement,
      bodyElement: _bodyElement,
      center: computedArrowSize !== 'none',
      content: renderedContent,
      distance: computedArrowParams.distance + _distanceAdjustment,
      inset: computedArrowParams.inset + _insetAdjustment,
      onFocusLeave: onFocusLeave,
      onTetherUpdate: handleTetherUpdate,
      open: tetherOpen,
      pinToConstraint: pinToConstraint,
      pinToOutOfBoundsTarget: pinToOutOfBoundsTarget,
      placement: computedPlacement,
      ref: computedPopoverRef,
      target: target,
      targetAttachment: targetAttachment,
      zIndex: zIndex
    };
  }

  return _react.default.createElement(_UIAbstractPopup.default, popupProps, children);
});
UIPopover.propTypes = (0, _extends2.default)({}, _UIPopoverContent.default.propTypes, {
  addTargetClasses: _propTypes.default.bool,
  arrowSize: _propTypes.default.oneOf(Object.keys(_UIPopoverArrow.default.ARROW_SIZES)),
  autoPlacement: _propTypes2.autoPlacementPropType,
  children: _propTypes.default.element,
  closeOnOutsideClick: _propTypes.default.bool.isRequired,
  closeOnTargetLeave: _propTypes.default.bool.isRequired,
  onFocusLeave: _propTypes.default.func,
  onChangePlacement: _propTypes.default.func,
  onOpenChange: _propTypes.default.func,
  pinToConstraint: _propTypes2.pinToConstraintPropType,
  pinToOutOfBoundsTarget: _propTypes.default.bool,
  popoverRef: _refObject.default,
  placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  shouldCloseOnClick: _propTypes.default.func,
  target: _domElement.default,
  targetAttachment: _propTypes.default.string.isRequired,
  zIndex: _propTypes.default.number.isRequired,
  _distanceAdjustment: _propTypes.default.number,
  _insetAdjustment: _propTypes.default.number,
  _bodyElement: _domElement.default
});
UIPopover.defaultProps = (0, _extends2.default)({}, _UIPopoverContent.default.defaultProps, {
  autoPlacement: true,
  closeOnOutsideClick: true,
  closeOnTargetLeave: false,
  _distanceAdjustment: 0,
  _insetAdjustment: 0,
  pinToConstraint: ['top', 'bottom'],
  pinToOutOfBoundsTarget: false,
  targetAttachment: 'auto',
  zIndex: _UIAbstractPopup.default.defaultProps.zIndex
});
var UIControlledPopover = UIPopover;
var _default = UIControlledPopover;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/tooltip/UIControlledPopover.js
// module id = 184
// module chunks = 0